<app-import-nav />

<h5 class="mt-3">ESP NDCs Import History</h5>

<div class="container-fluid p-2 border rounded bg-light">
  <form novalidate>
    <div class="row">
      <div class="filter mb-3 me-1 col-4" style="max-width: 100%">
        <app-client-select
          placeholder="Filter by Client"
          [multiple]="true"
          [autoLoad]="true"
          [listFilters]="{ applicableToReferralClaims: true }"
          [(ngModel)]="filters.selectedClientIds"
          (changed)="onFilterChange()"
        />
      </div>
    </div>
  </form>
</div>

@if (!loading) {
  <div>
    @if (clientEspNdcImports.length > 0) {
      <section class="mt-3">
        <div class="col-12">
          <app-pagination-header [paging]="paging" [label]="'imports'" (pageSizeChange)="onPageSizeChange($event)" />
        </div>
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>CLIENT</th>
              <th>STATUS</th>
              <th>IMPORTED FILE</th>
              <th>FILES</th>
              <th>DATE IMPORTED</th>
              <th class="text-end">TOTAL ROWS</th>
              <th class="text-end">PROCESSED</th>
              <th class="text-end">IMPORTED</th>
              <th class="text-end">REMOVED</th>
              <th class="text-end">SKIPPED</th>
            </tr>
          </thead>
          <tbody>
            @for (clientEspNdcImport of clientEspNdcImports; track clientEspNdcImport) {
              <tr>
                <td>{{ clientEspNdcImport.client.name }}</td>
                <td>
                  {{ clientEspNdcImport.status | titlecase }}
                  <fa-icon [hidden]="!clientEspNdcImport.active" [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" />
                  <div [hidden]="!clientEspNdcImport.active">
                    <button class="btn btn-sm btn-danger" (click)="onCancelClick($event, clientEspNdcImport)">CANCEL</button>
                  </div>
                </td>
                <td>
                  {{ clientEspNdcImport.filename }}
                </td>
                <td class="text-center">
                  <small>
                    <div ngbDropdown class="d-inline-block">
                      <button id="downloadDropdown" class="btn btn-sm btn-secondary" ngbDropdownToggle>Download</button>
                      <div ngbDropdownMenu aria-labelledby="downloadDropdown">
                        <a [hidden]="!clientEspNdcImport.hasSkippedFile"
                          class="dropdown-item btn-sm"
                          href="#downloadSkipped"
                          (click)="onDownloadSkippedClick($event, clientEspNdcImport)">
                          Skipped Records File
                        </a>
                        <a class="dropdown-item btn-sm"
                          href="#downloadOriginal"
                          (click)="onDownloadFileClick($event, clientEspNdcImport)">
                          Uploaded File
                        </a >
                      </div>
                    </div>
                  </small>
                </td>
                <td>
                  {{ clientEspNdcImport.createdAt | date: 'M/d/yyyy h:mm a' }}
                  <div>
                    <small>{{ clientEspNdcImport.user.email }}</small>
                  </div>
                </td>
                <td>{{ clientEspNdcImport.totalRows }}</td>
                <td>{{ clientEspNdcImport.processed }}</td>
                <td>{{ clientEspNdcImport.imported }}</td>
                <td>{{ clientEspNdcImport.removed }}</td>
                <td>{{ clientEspNdcImport.skipped }}</td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </section>
    } @else {
      <section class="mt-3"><p>There are no imports.</p></section>
    }
  </div>
} @else {
  <section class="mt-3"><mat-spinner diameter="30" /></section>
}
